import { nanoid } from 'nanoid'
import { type WorkflowActionId, type WorkflowStageId } from '@terros/common'

export function createId<T extends string>(prefix: T, length?: number): `${T}.${string}` {
  return `${prefix}.${nanoid(length)}`
}

export function createWorkflowActionId(): WorkflowActionId {
  return createId('A')
}

export function createWorkflowStageId(): WorkflowStageId {
  return createId('S')
}
